import LoadingIndicator from './loading-indicator';

export {LoadingIndicator};

export default LoadingIndicator;
